export default {
  products: {},
  singleProduct: {},
  productOrder: {},
  cartData: {},
  brandData: {},
  getAllVendor: {},
  vendorProds: {},
  getVendor: {},
  orderCount: {},
  affiliateUrlData: {},
};
